import { dispatch, getState } from '../../..';
import PumpingStationMotorTypeHelper, { IPumpingStationMotorType } from '../../../../@types/model/masterData/pumpingStation/motorType';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorTypeActions from './actions';

export default class MasterDataPumpingStationMotorTypeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorTypeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorTypeActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorTypeActions.set([]));

        try {
            MasterDataPumpingStationMotorTypeFunctions.listener = PumpingStationMotorTypeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorType>) => {
                    const state = getState().masterData.pumpingStation.motorType;

                    const list = state.motorTypes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorTypeActions.set(list));
                    dispatch(MasterDataPumpingStationMotorTypeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorTypeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorTypeActions.setLoading(false));
                    MasterDataPumpingStationMotorTypeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorTypeActions.setLoading(false));
        }
    };
}